module.exports = __webpack_public_path__ + "static/img/1.629dfa7.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/article/1.jpg
// module id = 5W8l
// module chunks = 1